import axios from 'axios';
import { profileGet } from './profileCache';
import { profileWrite } from './profileActions';
// Explicit imports keep unrelated portals, login and global Axios behavior intact.
const profileApi: typeof axios = Object.assign(Object.create(axios), {
  get: profileGet,
  post: (url: string, data: any, config: any) => profileWrite('POST', url, data, config),
  put: (url: string, data: any, config: any) => profileWrite('PUT', url, data, config),
  patch: (url: string, data: any, config: any) => profileWrite('PATCH', url, data, config),
});
export default profileApi;
